export default [
  {
    path: '/dashboard/spklu',
    name: 'dashboard-spklu',
    component: () => import('../../views/dashboard/dashboard_spklu'),
    meta: {
      title: 'Dashboard',
      activeMenu: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          disabled: true
        },
        {
          text: 'SPKLU',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/dashboard/home-charging',
    name: 'Dashboard homeCharging',
    component: () => import('../../views/dashboard/dashboard_homecharging'),
    meta: {
      title: 'Dashboard',
      activeMenu: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          disabled: true
        },
        {
          text: 'Home Charging',
          disabled: true
        }
      ]
    }
  }
]
